import { Component, OnInit } from '@angular/core';
import {ComponentBase} from '../../core/entities/component-base';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent extends ComponentBase implements OnInit {

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/loading/loading.component.ts